module.exports = __webpack_public_path__ + "img/3D.2adc4e14.png";